import { Controller } from "stimulus"

// Clé sessionStorage : marque que les pop-ups ont déjà été présentées pendant
// cette session de navigateur (vidée à la fermeture de l'onglet).
const SESSION_KEY = "metaCgpPopupsShown"

// Affiche les pop-ups de communication dans une seule modale Bootstrap, empilées
// les unes sous les autres. On n'y montre que les pop-ups actives non encore « vues ».
//
// La modale n'est présentée qu'une fois par session de navigateur (à l'entrée sur
// l'app) : un garde sessionStorage évite de la réafficher à chaque navigation.
//
// Logique « vue » (mémorisée côté client via localStorage, clé id + début d'affichage —
// donc changer la date de début d'affichage la réaffiche) :
//   - pop-up AVEC CTA  : marquée vue au clic sur le CTA ;
//   - pop-up SANS CTA  : marquée vue à la fermeture de la modale ;
//   - bouton « Ne plus afficher » d'une communication : marque cette pop-up vue.
export default class extends Controller {
  static targets = ["item"]

  connect() {
    // Déjà présentées dans cette session : on ne réaffiche pas à chaque page.
    if (this.shownThisSession()) return

    // On masque les pop-ups déjà vues ; on ne garde que celles à afficher.
    this.visibleItems = this.itemTargets.filter((item) => {
      if (this.seen(item)) {
        item.style.display = "none"
        return false
      }
      return true
    })

    if (this.visibleItems.length === 0) return

    this.markShownThisSession()

    // Pas de séparateur au-dessus de la première pop-up réellement affichée.
    this.visibleItems[0].classList.remove("border-top")

    this.boundOnHidden = () => this.onHidden()
    $(this.element).on("hidden.bs.modal", this.boundOnHidden)
    $(this.element).modal("show")
  }

  disconnect() {
    if (this.boundOnHidden) {
      $(this.element).off("hidden.bs.modal", this.boundOnHidden)
    }
  }

  // Clic sur un CTA : la pop-up correspondante est marquée vue (avant l'éventuelle
  // navigation dans le même onglet, l'écriture localStorage étant synchrone).
  ctaClicked(event) {
    const item = event.target.closest(".popup-item")
    if (item) this.remember(item)
  }

  // Bouton « Ne plus afficher » d'une communication : marque cette pop-up vue,
  // masque son bloc, et ferme la modale s'il ne reste plus rien à afficher.
  dontShowAgain(event) {
    const item = event.target.closest(".popup-item")
    if (!item) return

    this.remember(item)
    item.style.display = "none"
    this.visibleItems = this.visibleItems.filter((visible) => visible !== item)

    if (this.visibleItems.length === 0) {
      $(this.element).modal("hide")
    } else {
      // La nouvelle première communication ne doit pas garder de séparateur au-dessus.
      this.visibleItems[0].classList.remove("border-top")
    }
  }

  // Fermeture de la modale : les pop-ups SANS CTA encore visibles sont marquées vues.
  onHidden() {
    this.visibleItems
      .filter((item) => item.dataset.popupHasCta !== "true")
      .forEach((item) => this.remember(item))
  }

  shownThisSession() {
    try {
      return window.sessionStorage.getItem(SESSION_KEY) === "1"
    } catch (e) {
      return false
    }
  }

  markShownThisSession() {
    try {
      window.sessionStorage.setItem(SESSION_KEY, "1")
    } catch (e) {
      // sessionStorage indisponible : on retombe sur l'affichage par page.
    }
  }

  storageKey(item) {
    return item.dataset.popupStorageKey
  }

  seen(item) {
    try {
      return window.localStorage.getItem(this.storageKey(item)) === "1"
    } catch (e) {
      return false
    }
  }

  remember(item) {
    try {
      window.localStorage.setItem(this.storageKey(item), "1")
    } catch (e) {
      // localStorage indisponible (navigation privée, etc.) : on ignore.
    }
  }
}
